import { render, staticRenderFns } from "./newtag.vue?vue&type=template&id=e60f2a6a&scoped=true"
import script from "./newtag.vue?vue&type=script&lang=js"
export * from "./newtag.vue?vue&type=script&lang=js"
import style0 from "./newtag.vue?vue&type=style&index=0&id=e60f2a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60f2a6a",
  null
  
)

export default component.exports